import { QueryKey } from '@tanstack/react-query';
import { HealthcareEntityService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const healthcareEntityFacilityQueryKeys = new QueryKeyFactoryGenerator<
  DefaultQueryKeyFactory,
  {
    providerFacility: (id: string) => QueryKey;
    providerFacilityList: (id: string) => QueryKey;
    entityConnectedToProvider: (id: string) => QueryKey;
    listForSelect: () => QueryKey;
    providersList: () => QueryKey;
  }
>('facility', {
  providerFacility: (id: string): QueryKey => [
    ...healthcareEntityFacilityQueryKeys.allDetails(),
    'providerFacility',
    id,
  ],
  providerFacilityList: (id: string): QueryKey => [
    ...healthcareEntityFacilityQueryKeys.allDetails(),
    'providerFacilityList',
    id,
  ],
  entityConnectedToProvider: (id: string): QueryKey => [
    ...healthcareEntityFacilityQueryKeys.allDetails(),
    'entityConnectedToProvider',
    id,
  ],
  listForSelect: () => [...healthcareEntityFacilityQueryKeys.allDetails(), 'listForSelect'],
  providersList: () => [...healthcareEntityFacilityQueryKeys.allDetails(), 'providersList'],
}).getDefault<typeof HealthcareEntityService.healthcareEntityFacilitiesList, string>();
